import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var registerServiceWorker = createAction(actionKey + ".REGISTER_SERVICE_WORKER");
//# sourceMappingURL=actions.js.map